<template>
  <div
    class="dashboardarticles dasrtrts gw_box"
    style="--box-padding: 0"
    :class="{ gw_loading: loading }"
  >
    <div
      ref="top"
      class="gw_box gw_box_widget_title"
    >
      <DashboardArticleTypeSwitcher
        :value="selectedType"
        class="mr-auto"
        @update="handleTypeUpdate"
      />
      <GwPagination
        v-show="items.length && count > limit"
        class="ml-auto"
        :limit="limit"
        :offset="offset"
        :count="count"
        @update:offset="handleUpdateOffset"
      />
    </div>
    <div
      class="gw_box"
      style="--box-padding: 0"
    >
      <!-- <div class="gw_box" style="--box-padding: 0 1.75rem"> -->
      <div
        v-if="!loading ? items.length : true"
        class="dasrtrts_scroller"
      >
        <DashboardArticle
          v-for="item in items"
          :key="item.id"
          class="dasrtrts_scroller_item"
          :item="item"
        >
          <template #under_description>
            <div
              v-if="!item.description && item.type === 'VIDEO'"
              class="gw_btn-v1 mt-4 mr-auto"
            >
              <div class="mdi mdi-play text-semi-large mr-2"></div>
              {{ $t('btn.play_video') }}
            </div>
          </template>

          <template #before_tags>
            <span
              class="dasarttcsl_right_bottom_tags_tag"
              style="background: var(--clr-black-1-3)"
            >
              {{ $t(`dashboard_articles.type.${item.type.toLowerCase()}`) }}
            </span>
          </template>
          <template #after_tags>
            <div class="dasarttcsl_right_bottom_date">
              {{ formatISODate(item.published_at || item.created_at) }}
            </div>
          </template>
        </DashboardArticle>
        <div class="dasrtrts_loader anim-fade-in">
          <LoaderSpinner
            v-if="loading"
            :style="`--size:4rem`"
          />
        </div>
      </div>

      <div
        v-else
        class="dasrtrts_message anim-fade-in"
      >
        <div
          class="gw_box mb-auto flex-1 b-grey f-center f-column"
          style="--box-padding: 4rem"
        >
          <div
            class="text-semi-large clr-grey weight_400"
            v-html="$t('messages.dashboard_no_content')"
          ></div>
          <div
            v-if="error"
            class="clr-grey"
          >
            STATUS / {{ error.response ? error.response.status : 0 }}
          </div>
          <div
            class="gw_btn_text gw_btn_primary gw_btn_outline mx-auto gw_btn-v1 mt-4 px-8"
            style="--clr: var(--clr-primary)"
            @click="resetData"
          >
            <div class="mdi mdi-plus-circle mr-2 text-semi-large"></div>
            {{ $t('btn.reload') }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="!loading && items.length && count > limit"
      class="gw_box gw_box_widget_title"
    >
      <GwPagination
        class="ml-auto"
        :limit="limit"
        :offset="offset"
        :count="count"
        @update:offset="handleUpdateOffset"
      />
    </div>
  </div>
</template>

<script>
import LoaderSpinner from '@/components/Loaders/LoaderSpinner'
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'
import DashboardArticle from '@/components/Dashboard/DashboardArticle'
import DashboardArticleTypeSwitcher from '@/components/Dashboard/DashboardArticleTypeSwitcher'
import GwPagination from '@/components/lib/GwPagination'

export default {
  name: 'DashboardArticles',
  components: {
    DashboardArticle,
    GwPagination,
    DashboardArticleTypeSwitcher,
    LoaderSpinner,
  },
  mixins: [float_mix, format_mix],
  data() {
    this.limit = 12
    return {
      offset: 0,
      loading: false,
      error: false,

      count: 0,
      status: null,
      items: [],

      selectedType: '',
    }
  },
  created() {
    this.getData()
  },
  methods: {
    reset() {
      this.offset = 0
      this.loading = false
      this.error = false
      this.items = []
    },
    handleTypeUpdate(item) {
      if (this.selectedType === item.payload) return
      this.selectedType = item.payload
      this.resetData()
      this.scrollToTop()
    },
    scrollToTop() {
      if (this.$refs.top) {
        this.$refs.top.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
      }
    },
    handleUpdateOffset(offset) {
      if (this.loading) return
      this.offset = offset
      this.items = []
      this.loading = true
      this.getData()
      this.scrollToTop()
    },
    resetData() {
      this.items = []
      this.loading = true
      setTimeout(() => {
        this.reset()
        this.getData()
      }, 400)
    },
    async getData() {
      this.loading = true
      const params = {
        limit: this.limit,
        offset: this.offset,
        ...(this.selectedType ? { type: this.selectedType.toUpperCase() } : {}),
      }
      const res = await this.$store.dispatch('api_call', {
        method: 'GET',
        endpoint: `content/`,
        params,
        hasCancel: false,
      })

      this.loading = false
      this.error = !res || res?.error || !res?.response
      if (this.error) {
        return
      }

      const data = res?.response?.data
      this.count = data?.count || 0
      this.items = data?.results || []
    },
  },
  computed: {
    types() {
      const res = {
        id: 'content',
        title: this.$t(`common.content`),
        isSingle: true,
        options: ['video', 'announcement', 'article'],
        selected: this.selected.article,
      }
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.dasrtrts {
  --min-height: var(--vh-3);
  min-height: var(--min-height);
  display: flex;
  width: 100%;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  &_scroller {
    width: 100%;
    padding: 0 0.875rem;
    &_item {
      --padding-side: 0.875rem;
      border-bottom: solid 1px var(--clr-black-3);
    }
  }
  &_loader {
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0rem;
    z-index: 4;
    width: 100%;
    padding: 2rem;
  }
  &_message {
    flex: 1;
    display: flex;
    margin: 1rem 0 0 0;
  }
}

@media (hover: hover) and (pointer: fine) {
  .dasrtrts {
    &_scroller {
      &_item {
        &::before {
          content: '';
          background: var(--clr-black-1-3);
          height: calc(100% - 2rem);
          width: 100%;
          left: 0;
          top: 1rem;
          position: absolute;
          border-radius: 1rem;
          overflow: hidden;
          z-index: 0;
          opacity: 0;
          transition: opacity 0.2s ease;
        }
        &:hover {
          &::before {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
